import { graphql } from "babel-plugin-relay/macro";
import { Button } from "primereact/button";
import { useFragment, useMutation } from "react-relay";
import { CreateAwardPharmaPointsRewardButton_TreeNodeFragment$key } from "../../../../__generated__/CreateAwardPharmaPointsRewardButton_TreeNodeFragment.graphql";
import { CreateAwardPharmaPointsRewardButton_AddPharmaPointsMutation } from "../../../../__generated__/CreateAwardPharmaPointsRewardButton_AddPharmaPointsMutation.graphql";

const MUTATION = graphql`
	mutation CreateAwardPharmaPointsRewardButton_AddPharmaPointsMutation(
		$input: AddPharmaPointsRewardInput!
	) {
		Admin {
			Tree {
				addPharmaPointsReward(input: $input) {
					contentNode {
						...RewardEditor_TreeNodeFragment
					}
				}
			}
		}
	}
`;

const FRAGMENT = graphql`
	fragment CreateAwardPharmaPointsRewardButton_TreeNodeFragment on TreeNode {
		id
		typeDefinition {
			... on ELearningContentTypeDefinition {
				rewards {
					id
					kind
				}
			}
		}
	}
`;

interface OwnProps {
	treeNodeFragmentRef: CreateAwardPharmaPointsRewardButton_TreeNodeFragment$key;
}

export const CreateAwardPharmaPointsRewardButton = ({ treeNodeFragmentRef }: OwnProps) => {
	const node = useFragment<CreateAwardPharmaPointsRewardButton_TreeNodeFragment$key>(
		FRAGMENT,
		treeNodeFragmentRef,
	);
	const [addReward, isAdding] =
		useMutation<CreateAwardPharmaPointsRewardButton_AddPharmaPointsMutation>(MUTATION);

	return (
		<Button
			className={"mr-2"}
			disabled={isAdding}
			tooltip={"BAK Punkte vergeben"}
			tooltipOptions={{ position: "top" }}
			icon="pi pi-bolt"
			onClick={() => {
				addReward({
					variables: {
						input: {
							contentNodeId: node.id,
							amount: 1,
						},
					},
				});
			}}
		/>
	);
};
